import axios from 'axios';
import SummaryCard from 'components/cards/SummaryCard';
import { errorHandler } from 'helpers/response-utils';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import iconTotalUsers from 'assets/img/icons/01_total_users.svg';
import iconWallet from 'assets/img/icons/02_wallet.svg';
import iconwmdrwallet from 'assets/img/icons/03_wmdr_unlocked.svg';
import iconwmdrusers from 'assets/img/icons/04_wmdr_users.svg';
import icontotalpoints from 'assets/img/icons/05_total_points.svg';
import iconwelcomerewardpoints from 'assets/img/icons/06_welcome_reward_points.svg';
import iconrewardclaimedpoints from 'assets/img/icons/07_reward_claimed_points.svg';
import iconaivalidationpoints from 'assets/img/icons/08_gulp_ai_points.svg';
import iconqualifiedpoints from 'assets/img/icons/09_logged_cup_points.svg';
import iconsmartbottlepoints from 'assets/img/icons/10_smart_bottle_points.svg';
import iconclaimedtokens from 'assets/img/icons/11_claimed_tokens.svg';
import iconburnedtokens from 'assets/img/icons/12_burned_tokens.svg';

const DashBoardSummary = () => {
  const [wmdrSummary, setWmdrSummary] = useState(null);
  const token = localStorage.getItem('token');
  const iconsBase = process.env.PUBLIC_URL || '';
  useEffect(() => {
    getWmdrSummary();
  }, []);

  const getWmdrSummary = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}/dashboard`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    errorHandler(response);

    if (response.data['status'] == 'error') {
      toast.error(response.data['message']);
      return false;
    }
    setWmdrSummary(response.data['data']);
  };

  return (
    <>
      <Row className="gy-3 mb-6 justify-content-between">
        <Col md={9} xs="auto">
          <h2 className="mb-2 text-body-emphasis">Hydration Points Summary</h2>
        </Col>
      </Row>
      {wmdrSummary && (
        <SummaryCard
          sectionTitle="Summary"
          wmdrUserFields={[
            {
              key: 'total_users',
              label: 'Total Users',
              fmt: 'int',
              icon: iconTotalUsers
            },
            {
              key: 'unique_wallets',
              label: 'Unique Wallets',
              fmt: 'int',
              icon: iconWallet
            }
          ]}
          summary={wmdrSummary}
        />
      )}

      {wmdrSummary && (
        <SummaryCard
          sectionTitle="FUNN Users"
          wmdrUserFields={[
            {
              key: 'wmdr_count',
              label: 'Funn Unlocked',
              fmt: 'int',
              icon: iconwmdrwallet
            },
            {
              key: 'welcome_reward_claims',
              label: 'Funn Users',
              fmt: 'int',
              icon: iconwmdrusers
            }
          ]}
          summary={wmdrSummary}
        />
      )}

      {wmdrSummary && (
        <SummaryCard
          sectionTitle="Points Summary"
          wmdrUserFields={[
            {
              key: 'total_points',
              label: 'Total Points',
              fmt: 'float2',
              icon: icontotalpoints
            },
            {
              key: 'welcome_reward_points',
              label: 'Welcome Reward Points',
              fmt: 'int',
              icon: iconwelcomerewardpoints
            },
            {
              key: 'reward_claimed_points',
              label: 'Reward Claimed Points',
              fmt: 'float2',
              icon: iconrewardclaimedpoints
            },
            {
              key: 'aivalidation_points',
              label: 'Gulp AI Points',
              fmt: 'float2',
              icon: iconaivalidationpoints
            },
            {
              key: 'qualified_points',
              label: 'Logged Cup Points',
              fmt: 'float2',
              icon: iconqualifiedpoints
            },
            {
              key: 'smart_bottle_points',
              label: 'Smart Bottle Points',
              fmt: 'float2',
              icon: iconsmartbottlepoints
            }
          ]}
          summary={wmdrSummary}
        />
      )}

      {wmdrSummary && (
        <SummaryCard
          sectionTitle="Tokenomics"
          wmdrUserFields={[
            {
              key: 'claimed_tokens',
              label: 'Claimed Tokens',
              fmt: 'float3',
              icon: iconclaimedtokens
            },
            {
              key: 'burned_tokens',
              label: 'Burned Tokens',
              fmt: 'int',
              icon: iconburnedtokens
            }
          ]}
          summary={wmdrSummary}
        />
      )}
    </>
  );
};

export default DashBoardSummary;
